import React from "react";
import { Box, Typography } from "@mui/material";
import oliImage from "../images/OLI LOGO WHITE PIPE.svg";

function TitleBox({ title }: { title: string }) {
  return (
    <Box padding={3} textAlign="center" sx={{ backgroundColor: "#05111D" }}>
      <img src={oliImage} alt="Logo" />
      <Typography variant="h4" color="#f4b43c">
        {title}
      </Typography>
    </Box>
  );
}

export default TitleBox;
